import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CookieService } from '../services/cookie.service';
import { User } from '../models/auth.models';
import {environment} from '../../../environments/environment';
import {token} from "flatpickr/dist/utils/formatting";

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  user: User;
  apiUrl: '';
  token: string;

  constructor(private http: HttpClient, private cookieService: CookieService) {
  }

  /**
   * Returns the current user
   */
  public currentUser(): User {
    if (!this.user) {
      this.user = JSON.parse(this.cookieService.getCookie('currentUser'));
    }
    return this.user;
  }

  isAuthenticated() {
    var token = localStorage.getItem('authToken');
    if (token === null) {
      console.log('hit it', token);
    } else {
      console.log(' out hit  it', token);
    }

    return false;
  }

  /**
   * Performs the auth
   * @param email email of user
   * @param password password of user
   */
  login(email: string, password: string) {

    return this.http.post(environment.apiUrl + 'api-login',  { email, password }, this.getHttpOptions());
    // return this.http.post<any>(`/api/login`, { email, password })
    //     .pipe(map(user => {
    //         // login successful if there's a jwt token in the response
    //         if (user && user.token) {
    //             this.user = user;
    //             // store user details and jwt in cookie
    //             this.cookieService.setCookie('currentUser', JSON.stringify(user), 1);
    //         }
    //         return user;
    //     }));
  }

  /**
   * Logout the user
   */
  logout() {
    // remove user from local storage to log user out
    this.cookieService.deleteCookie('currentUser');
    this.user = null;
    this.token = null;
    localStorage.setItem('authToken', null);
  }

  getHttpOptions() {
    return  {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  }

  getEstimate(estimate_ref) {
    return this.http.post(environment.apiUrl + 'get-estimate',  { estimate_ref }, this.getHttpOptions());
  }
}

